import Vue from 'vue'
import Vuex from 'vuex'
import globalJs from './state.js'
import login from './modules/login.js'
import { staticPath } from '@/utils/baseUrl.js'
let modulesFiles = []
if(staticPath == '/') { // 抖音平台-vuex-modules
	modulesFiles = require.context('./modules/dy' , true, /\.js$/)
} else { // 非抖音平台-vuex-modules
	modulesFiles = require.context('./modules/ks' , true, /\.js$/)
} 
import createLogger from 'vuex/dist/logger'
let fileListFun = (list) => {
	return list.keys().reduce((moduless, modulePath) => {
		const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1').split('/')[ modulePath.replace(/^\.\/(.*)\.\w+$/, '$1').split('/').length - 1]
		const value = list(modulePath)
		moduless[moduleName] = value.default
		return moduless
	}, {})
}
const modules = fileListFun(modulesFiles)
const commonList = fileListFun(require.context('./modules/common' , true, /\.js$/))
Vue.use(Vuex)
export default new Vuex.Store({
	...globalJs,
	modules: {
		login,
		...commonList,
		...modules
	},
	plugins: [createLogger()]
})